export const SIGNIN = 'lumahealth/LoginPage/SIGNIN';
export const SIGNIN_SUCCESS = 'lumahealth/LoginPage/SIGNIN_SUCCESS';
export const SIGNIN_ERROR = 'lumahealth/LoginPage/SIGNIN_ERROR';
